<div class="layout-1-auto">
	<div class="content">
<!-- 			<div class="content app-sidebar-wide bg-white"> -->
<!-- 				<div [class.app-bg-sub-sidebar]="true" [class.active]="true"> -->
<!-- 					<i class="fal fa-filter" ></i> -->
<!-- 					<em> -->
<!-- 						Filter -->
<!-- 					</em> -->
<!-- 				</div> -->
<!-- 				<div class=""> -->
<!-- 					<i class="fal fa-table"></i> -->
<!-- 					<em>Tabelle</em> -->
<!-- 				</div> -->
<!-- 			</div> -->
		<app-exg-tab-v2 #VCrightTabControl (tabchange)="rightTabs_tabChange($event)"
		         [header]="rightTabs">
			<ng-template #pages>
				<div class="content">
					<app-layout-table [mainTable]="mainTable">
					</app-layout-table>
				</div>
				<div class="content">
					<app-layout-filter [uiFilter]="uiFilter">
					</app-layout-filter>
				</div>
				<div class="content">
					<app-layout-sort [uiSort]="uiSort">
					</app-layout-sort>
				</div>
				<div class="content">
					<app-layout-views>
					</app-layout-views>
				</div>
			</ng-template>
		</app-exg-tab-v2>
	</div>
	<div class="spawn-reverse typo-small">
		<button (click)="action()" class="md-btn disabled">
			{{getGlobal('Anwenden')}}
		</button>
		<button (click)="action()" class="md-btn disabled">
			{{getGlobal('Save')}}
		</button>
	</div>
</div>
